export default "{\n    \"heading\": \"Construction\",\n    \"headings\": {\n        \"newProject\": \"New Project\"\n    }\n}\n"